<app-widget [widget-meta]="this.data"
  class="widget-announcements"
  alertCount="{{( annoucementService.summary$ | async)?.unread}}">

  <!-- To ensure uniqueness, individual items in the list are identified using the format
  [widget]-[feature]-[group]-[index]
  where...
  widget: ann = announcements
  feature: col = collapse
  group: unr or dis = unread or dismissed
  index: # = the index of the item
  -->

  @if (annoucementService.summary$ | async; as summary) {
    <div id="accordion" class="card-expansion">
      <ng-container *ngFor="let unread of annoucementService.undismissed$ | async as items; index as i">
        <div class="accordion" id="accordion">
          <ng-container [ngTemplateOutlet]="announcementCard" [ngTemplateOutletContext]="{announcement:unread, index:i, group:'unr-'}"></ng-container>
        </div>
      </ng-container>
      @if (summary.dismissed > 0) {
        <button class="btn btn-outline-primary btn-sm mb-2" (click)="this.showDismissed = !this.showDismissed">{{ (showDismissed) ? 'Hide' : 'Reveal'}} {{ summary.revealMessage }}</button>
      }
      @if (this.showDismissed) {
        <ng-container *ngFor="let dismissed of annoucementService.dismissed$ | async as items; index as i">
          <div class="accordion" id="accordion">
            <ng-container [ngTemplateOutlet]="announcementCard" [ngTemplateOutletContext]="{announcement:dismissed, index:i, group:'dis-'}"></ng-container>
          </div>
        </ng-container>
      }
      @if (summary.unread === 0 && summary.dismissed === 0) {
        <div class="row">
          <div class="col-md-12">
            <span class="detail">Hey! You don't have any announcements at the moment. Check back later.</span><br />
          </div>
        </div>
      }
    </div>
  } @else {
    <div class="widget-loading text-center">
      <i class="fas fa-circle-notch fa-spin"></i>
    </div>
  }

  <!-- The "Loading" template -->

  <!-- The "Announcement" template -->
  <ng-template #announcementCard let-announcement="announcement" let-index="index" let-group="group">
    <div class="accordion-item mb-2">
      <div class="accordion-header" [id]="'heading'+group+index">
                <header [ngClass]="{ 'alert-primary': announcement.AnnouncementType == 'Announcement' || announcement.AnnouncementType == 'None',
                                    'alert-warning': announcement.AnnouncementType == 'Warning',
                                    'alert-unc-green': announcement.AnnouncementType == 'Event'}"
          class="alert has-icon">
          <div class="container">
            <div class="row d-flex justify-content-between align-items-center">
              <div class=" alert-icon">
                                <i [ngClass]="{ 'fa-bullhorn': announcement.AnnouncementType == 'Announcement' || announcement.AnnouncementType == 'None',                                   
                            'fa-exclamation fa-xl': announcement.AnnouncementType == 'Warning',
                            'fa-calendar': announcement.AnnouncementType == 'Event'}"
                class="fa-solid"></i>
              </div>
              <div class="col-auto">
                <button class="accordion-button collapsed w-100 ms-1" type="button" data-bs-toggle="collapse" [attr.data-bs-target]="'#ann-col-' + group + index" aria-expanded="false" [attr.aria-controls]="'ann-col-' + group + index">
                  <span class="announcement-title">{{ announcement.Title }}</span>
                </button>
              </div>
              <div class="col-auto">
                <button class="btn btn-sm btn-primary mt-2" (click)="toggleDismissed(announcement)">
                  @if (announcement.isDismissed) {
                    <i class="fas fa-eye" aria-label="Restore" title="Restore"></i>
                  }
                  @if (!announcement.isDismissed) {
                    <i class="fas fa-eye-slash" aria-label="Dismiss" title="Dismiss"></i>
                  }
                  <span class="sr-only">{{announcement.isDismissed ? 'Restore' : 'Dismiss'}} announcement</span>
                </button>
              </div>
            </div>
          </div>
        </header>

      </div>
      <div [id]="'ann-col-' + group + index" class="accordion-collapse collapse" [attr.aria-labelledby]="'heading'+group+index" data-bs-parent="#accordion">
        <div class="accordion-body">
          <div class="announcement-body card-body">
            <h3 class="announcement-title-inbody">{{ announcement.Title }} </h3>
            <span [innerHTML]="announcement.Html"></span>
            <button class="btn btn-link btn-sm" (click)="toggleDismissed(announcement)">
              [{{announcement.isDismissed ? 'Restore' : 'Dismiss'}}]
            </button>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

</app-widget>
